import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminNav from "./components/AdminNav.jsx";
import AdminHeader from "./components/AdminHeader.jsx";
import Login from "./components/AdminLogin.jsx";
import AdminControl from "./pages/AdminControlPage.jsx";
import AdminPublications from "./pages/AdminPublications.jsx";
import AdminBlog from "./pages/AdminBlog.jsx";

import AdminTeam from "./pages/AdminTeampage.jsx";
import AdminInsolvencyCases from "./pages/AdminInsolvencyCases.jsx";
import AdminGangaPage from "./pages/AdminGangaPage.jsx";
import AdminSakthiGaneshPage from "./pages/AdminSakthiGaneshPage.jsx";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/*"
          element={
            <div className="admin-main">
              <AdminNav />
              <div className="admin-content-wrapper" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <AdminHeader />
                <div className="admin-content">
                  <Routes>
                    <Route path="/admincontrol" element={<AdminControl />} />
                    <Route path="/adminpublications" element={<AdminPublications />} />
                    <Route path="/adminblog" element={<AdminBlog />} />

                    <Route path="/adminteam" element={<AdminTeam />} />
                    <Route path="/admininsolvencycases" element={<AdminInsolvencyCases />} />
                    <Route path="/adminganga" element={<AdminGangaPage />} />
                    <Route path="/adminsakthiganesh" element={<AdminSakthiGaneshPage />} />
                  </Routes>
                </div>
              </div>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
